<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Select Customer</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="searchCustomersInput">Search Customers</label>
      <input type="text" class="form-control" id="searchCustomersInput"
             name="searchCustomersInput"
             ngbAutofocus
             [(ngModel)]="search"
             (ngModelChange)="handleCustomerFilterChange()">
    </div>

    <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto">

      <ng-container *ngIf="hasSearchInput() && (selectedCustomer === null)">

        <table class="table table-bordered table-hover">
          <tbody *ngIf="!customerResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingCustomers ? 'Loading...' : 'No results' }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="customerResultsPresent()">
            <tr style="cursor:pointer"
                *ngFor="let customer of filteredCustomerResults()"
                (click)="selectCustomer(customer)">
              <td>
                {{ customer.first_name }} {{ customer.last_name }}
                <span class="text-muted">
                  {{ dateStringFromISO8601(customer.birthday )}}
                  <span *ngIf="customer.email">- {{ customer.email }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="alert alert-info" *ngIf="!loadingCustomers && hasRecentActivityFilter()">
          Only recently-active customers are being shown.
          <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
            Expand search to all customers.
          </a>
        </div>

      </ng-container>

    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Submit
    </button>
  </div>

</ng-container>
